import { IWorkoutAggregateFilter } from './actions';

const ALL_TIME_START_DATE = new Date(2000, 0, 1);
const ALL_TIME_END_DATE = new Date(3000, 0, 1);

export const ALL_TIME_FILTER: IWorkoutAggregateFilter = {
  startDate: ALL_TIME_START_DATE,
  endDate: ALL_TIME_END_DATE,
} as IWorkoutAggregateFilter & { customFilter: boolean };

export function isAllTimeFilter(
  filter?: IWorkoutAggregateFilter | { startDate?: Date, endDate?: Date } | null,
): boolean {
  if (!filter?.startDate || !filter?.endDate) {
    return false;
  }
  return filter.startDate.getFullYear() <= ALL_TIME_START_DATE.getFullYear()
    && filter.endDate.getFullYear() >= ALL_TIME_END_DATE.getFullYear() - 1;
}
